import { createAction, props } from '@ngrx/store';
import { IGlimpseUser } from 'src/app/modules/auth/models/IGlimpseUser';
import { IFeatureResponse } from '../../modules/customer-shared/models/IFeatureResponse';

export const login = createAction('[Auth] Login', props<{ username: string; password: string }>());

export const logout = createAction('[Auth] Logout');

export const loginSuccess = createAction('[Auth] Login Success', props<{ user: IGlimpseUser; token: string }>());

export const loginFailed = createAction('[Auth] Login Failed', props<{ username: string; error: string }>());

export const received401Action = createAction('[Auth] Action Is Unauthorized');
export const received403Action = createAction('[Auth] Action Is Forbidden');
export const received409Action = createAction('[Auth] Resource Is In Use');

export const actionNeedsAuthentication = createAction(
  '[Auth] Action Needs Authentication',
  props<{ returnUrl: string }>(),
);

export const actionPasswordResetRequest = createAction('[Auth] Password Reset Request', props<{ email: string }>());

export const actionPasswordResetRequestSuccess = createAction('[Auth] Password Reset Request Success');

export const actionPasswordResetRequestFailed = createAction(
  '[Auth] Password Reset Request Failed',
  props<{ error: string }>(),
);

export const actionPasswordResetSubmit = createAction(
  '[Auth] Password Reset',
  props<{ email: string; password: string; token: string }>(),
);

export const actionPasswordResetSuccess = createAction('[Auth] Password Reset Success', props<{ email: string }>());

export const actionPasswordResetFailed = createAction('[Auth] Password Reset Failed', props<{ error: string }>());

export const updateUser = createAction('[Profile Page] Update Profile', props<{ user: IGlimpseUser }>());

export const impersonationSuccess = createAction(
  '[Auth] Impersonation Success',
  props<{ user: IGlimpseUser; token: string }>(),
);
export const finishImpersonation = createAction('[Auth] Finish Impersonation');

export const pushEnable = createAction('[Auth] Push Enable', props<{ sub: PushSubscription }>());
export const pushEnableSuccess = createAction('[Auth] Push Enable Success');
export const pushEnableFail = createAction('[Auth] Push Enable Fail');

export const pushDisable = createAction('[Auth] Push Disable', props<{ sub?: PushSubscription }>());
export const pushDisableSuccess = createAction('[Auth] Push Disable Success');
export const pushDisableFail = createAction('[Auth] Push Disable Fail');

export const loadProfile = createAction('[Auth] Load Profile');
export const loadProfileSuccess = createAction('[Auth] Load Profile Success', props<{ user: IGlimpseUser }>());
export const loadProfileFail = createAction('[Auth] Load Profile Fail');

export const loadFeatures = createAction(
  '[Onboarding] Load Features',
  props<{ for: 'All' | 'User' | 'Recent'; period?: Date }>(),
);
export const loadFeaturesSuccess = createAction(
  '[Onboarding] Load Features Success',
  props<{ features: IFeatureResponse[]; recentCount: number }>(),
);
export const loadFeaturesError = createAction('[Onboarding] Load Features Error', props<{ error: Error }>());
